/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BasketsPostRequestServiceItemsInner model module.
 * @module model/BasketsPostRequestServiceItemsInner
 * @version 1.0.0
 */
class BasketsPostRequestServiceItemsInner {
    /**
     * Constructs a new <code>BasketsPostRequestServiceItemsInner</code>.
     * @alias module:model/BasketsPostRequestServiceItemsInner
     */
    constructor() { 
        
        BasketsPostRequestServiceItemsInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BasketsPostRequestServiceItemsInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BasketsPostRequestServiceItemsInner} obj Optional instance to populate.
     * @return {module:model/BasketsPostRequestServiceItemsInner} The populated <code>BasketsPostRequestServiceItemsInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BasketsPostRequestServiceItemsInner();

            if (data.hasOwnProperty('productId')) {
                obj['productId'] = ApiClient.convertToType(data['productId'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BasketsPostRequestServiceItemsInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BasketsPostRequestServiceItemsInner</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * ID of the product to add
 * @member {Number} productId
 */
BasketsPostRequestServiceItemsInner.prototype['productId'] = undefined;






export default BasketsPostRequestServiceItemsInner;

